export default {
  'meta': {
    'langName': 'TURKISH',
    'lang': 'Türkçe'
  },
  'title': 'ÜRÜN GERİ ÇAĞIRMA: BASKETBOL POTASI B900 BOX NBA TARMAK',
  'description': 'Merhaba,\n\nYakın zamanda bir Tarmak B900 BOX NBA basketbol potası satın aldığınız için teşekkür ederiz.\n\nDECATHLON Basketbol ekibi olarak, devam eden ürün kalitesi ve güvenliği taahhüdümüzün bir parçası olarak,yükseklik ayar kolu çıkarıldığında ve pota hareket ettirildiğinde veya kullanıldığında direğin aniden aşağı düşme riski bulunduğunu belirledik.\n\nBu nedenle, size en uygun güvenlik çözümünü sunabilmemiz için birkaç soruyu yanıtlamanızı rica ediyoruz.\n\nBu durumdan kaynaklanan rahatsızlıktan dolayı özür diler, güveniniz için teşekkür ederiz.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Size en doğru bilgiyi sağlayabilmemiz için lütfen e-posta adresinizi ve ikamet ettiğiniz ülkeyi seçiniz:'
  },
  'fields': {
    'country': 'Ülke',
    'address': 'E-posta Adresi',
    'email': 'E-posta Adresi',
    'phonePrefix': 'Telefon numarası kodu',
    'phone': 'Telefon numarası',
    'validations': {
      'phoneOrEmail': 'Lütfen en az bir e-posta adresi veya bir telefon numarası belirtin.',
      'email': 'Lütfen geçerli bir e-posta adresi girin',
      'phone': 'Lütfen geçerli bir telefon numarası girin'
    },
    'firstName': 'Soyisim',
    'lastName': 'İsim',
    'deliveryAddress': 'Paketin gönderileceği adres',
    'additionalAddress': 'Ek adres detayları',
    'city': 'Şehir',
    'zip': 'Posta Kodu',
    'choose': 'Seçiniz',
    'required': 'Bu alan zorunludur'
  },
  'ownerCheck': {
    'title': 'Hala bir veya daha fazla B900 BOX NBA basketbol potasına sahip misiniz?'
  },
  'yes': 'EVET',
  'no': 'HAYIR',
  'ownerChanged': {
    'title': 'Eğer potaya artık sahip değilseniz, mevcut sahibinin/sahiplerinin iletişim bilgilerini biliyor musunuz?',
    'confirmation': 'Sayın Müşterimiz,\n\nBu kalite girişimine katılımınız için teşekkür ederiz.\n\nYaşanan rahatsızlıktan dolayı özür diler, güveniniz için teşekkür ederiz.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Lütfen takılı olan yükseklik ayar kolu tipine göre sahip olduğunuz basketbol potası sayısını belirtin.',
    'descriptionRed': 'Çıkarılabilir kırmızı yükseklik ayar koluna sahip basketbol potası',
    'descriptionBlack': 'Çıkarılabilir siyah yükseklik ayar koluna sahip basketbol potası',
    'quantity': 'Adet',
    'notConcerned': 'Sayın Müşterimiz,\n\nBu kalite girişimine katılımınız için teşekkür ederiz.\n\nTarmak B900 BOX NBA basketbol potanızın geri çağırma sürecinden etkilenmediğinden ve güvenle kullanılabileceğinden emin olabilirsiniz.\n\nYaşanan rahatsızlıktan dolayı özür diler, güveniniz için teşekkür ederiz.\n\nDECATHLON',
    'concernedProductQuantity': 'Uygun olmayan ürün miktarı:',
    'concernedProductLabel': 'Uygun olmayan ürün:',
    'confirmation': 'Formu doldurduğunuz için teşekkür ederiz. Talebiniz başarıyla kaydedilmiştir.\n\nKit teslimatınızın takip numarasını en kısa sürede size göndereceğiz.\n\nHarika bir gün dileriz.\n\nDECATHLON'
  },
  'repair': {
    'title': 'Sizin Katılımınızla Onarım',
    'description': 'Belirli TARMAK B900 BOX NBA basketbol potalarında (referans: 4239136), yükseklik ayar kolunun çıkarılması ve ürünün taşınması veya kullanılması durumunda direğin dikey olarak düşme riski olduğunu tespit ettik.\n\nYanıtlarınıza göre, ürününüzün bu riskten etkilendiği anlaşılmaktadır.\n\nBu nedenle, ürünü kullanmayı derhal bırakmanızı rica ediyoruz. Ürününüzü güvenle kullanabilmeniz için yükseklik ayar kolunun uyarlanmasında size yardımcı olmayı teklif ediyoruz.\n\nEndişelenmeyin, bu onarım özel bir uzmanlık gerektirmez; her şey aşağıdaki video ve kullanım kılavuzunda açıkça açıklanmıştır:',
    'videoLink': 'Video Linki',
    'docLink': 'Dosya Linki',
    'callToAction': 'Ücretsiz onarım kitinizi almak için buraya tıklayın',
    'warranty': 'Tüm süreç, 5 yıllık garantimiz kapsamındadır.'
  },
  'repairRequest': {
    'title': 'Ücretsiz kitinizin istediğiniz adrese gönderilebilmesi için lütfen aşağıdaki bilgileri girin:'
  },
  'form': {
    'submit': 'Sonraki'
  },
  'status': 'Translation validated by COUNTRY'
} as const
